import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import {EntityPerformanceDefaults} from "../../model/entity-performance-defaults";
import {PerformanceDefaultsService} from "../../services/performance-defaults.service";
import {PerformanceDefaults} from "../../model/performance-defaults";

import {PerformanceDefaultsComponent} from "../performance-defaults/performance-defaults.component";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
    selector: 'app-entity-performance-defaults',
    imports: [
    PerformanceDefaultsComponent,
    MatProgressSpinner
],
    templateUrl: './entity-performance-defaults.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './entity-performance-defaults.component.css'
})
export class EntityPerformanceDefaultsComponent implements OnInit {
  private readonly defaultsService = inject(PerformanceDefaultsService);


  readonly entityId = input.required<string>();
  readonly revision = input.required<number>();
  readonly errorEvent = output<any>();
  readonly entityPerformanceDefaults = signal<EntityPerformanceDefaults>(undefined!);
  readonly isBusy = signal<boolean>(undefined!);

  ngOnInit(): void {
    this.isBusy.set(true);
    this.defaultsService.getDefaultValues(this.entityId(), this.revision()).subscribe({
      next: (defaults: PerformanceDefaults) => {
        this.entityPerformanceDefaults.set(new EntityPerformanceDefaults());
        this.entityPerformanceDefaults().entityId = this.entityId();
        this.entityPerformanceDefaults().entityRevision = this.revision();
        this.entityPerformanceDefaults().performanceDefaults = defaults;
        this.isBusy.set(false);
      }, error: (error: any) => this.handleError(error)
    });
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorEvent.emit(error);
  }

  performanceDefaultUpdated(defaults: PerformanceDefaults): void {
    this.isBusy.set(true);
    this.entityPerformanceDefaults().performanceDefaults = defaults;
    this.defaultsService.saveEntityDefaults(this.entityPerformanceDefaults()).subscribe({
      next: (updated: EntityPerformanceDefaults) => {
        this.entityPerformanceDefaults.set(updated);
        this.isBusy.set(false);
      }, error: (error: any) => this.handleError(error)
    });
  }

}
